// extracted by mini-css-extract-plugin
export var component = "TextInput-module--component--9db69";
export var fadePop = "TextInput-module--fade-pop--fcccc";
export var growHeightIn = "TextInput-module--grow-height-in--8537a";